import { ElementShowImages } from "../../../features/base/image/list/ElementShowImages";
import { ObjectTarget } from "../../../app/permissions";

interface StudentImagesProps {
  schoolId: string;
  studentId: string;
  classroomId?: string;
  canDeleteImage: boolean;
}

const StudentImages = (props: StudentImagesProps) => {
  return <ElementShowImages
    request={{
      targetType: ObjectTarget.STUDENT,
      targetId: props.studentId,
    }}
    toolbar={{
      label: "Imagens",
    }}
    messages={{
      empty: "Não há imagens do aluno",
      error: "Erro ao carregar imagens"
    }}
    schoolId={props.schoolId}
    canDelete={props.canDeleteImage}
  />;

};

export default StudentImages;